// Cartes intelligentes du fil (lot 553) : Live en cours, Anniversaires, Chaîne de prière, Témoignage de la
// semaine, Prières à la une. Une seule carte en tête (la plus prioritaire), les autres glissées entre les
// publications (après la 3e, 7e, 11e…) ; une carte vue n'est pas remontrée avant `cooldown_hours` sauf nouveau
// contenu (clé de contenu différente) ; « × » la masque jusqu'au prochain contenu nouveau.
// Réglages admin : settings.smart_cards { enabled, cooldown_hours }.
// Lot 695 — « Promo du jour » (Marketplace) : priorité la plus basse, jamais devant un Live ou un anniversaire.
// Lot 791 — « Annonce mise en avant » (boostée par son vendeur) puis « Marketplace pour toi » ferment la marche.
export const SMART_CARD_KEYS = ["live_now", "birthday", "prayer_chain", "testimony", "prayers_spotlight", "promo_day", "market_for_you"];
export const SMART_CARD_LABELS = {
  live_now: "Live en cours", birthday: "Anniversaire du jour", prayer_chain: "Chaîne de prière active",
  testimony: "Témoignage de la semaine", prayers_spotlight: "Prières à la une", promo_day: "Promo du jour (Marketplace)",
  market_for_you: "Marketplace pour toi (annonce mise en avant)",
};
export const DEFAULT_FEED_POSITIONS = [3, 7, 11];
const STORE_KEY = "yalola.smartCards";

export const smartCardsConfig = (settings) => {
  const sc = settings?.smart_cards || {};
  const hours = Number(sc.cooldown_hours);
  return {
    enabled: sc.enabled !== false,
    cooldownMs: (hours >= 1 && hours <= 168 ? hours : 24) * 3600 * 1000,
    order: SMART_CARD_KEYS,
  };
};

const read = () => {
  try { const v = JSON.parse(localStorage.getItem(STORE_KEY) || "{}"); return { seen: v.seen || {}, dismissed: v.dismissed || {} }; }
  catch { return { seen: {}, dismissed: {} }; }
};
const write = (v) => { try { localStorage.setItem(STORE_KEY, JSON.stringify(v)); } catch { /* noop */ } };

export const isCardEligible = (key, contentKey, cfg, now = Date.now()) => {
  if (!contentKey) return false;
  const { seen, dismissed } = read();
  if (dismissed[key] === contentKey) return false;
  const s = seen[key];
  if (s && s.ck === contentKey && now - s.at < cfg.cooldownMs) return false;
  return true;
};
export const markCardSeen = (key, contentKey) => {
  if (!contentKey) return;
  const v = read();
  v.seen[key] = { ck: contentKey, at: Date.now() };
  write(v);
};
export const dismissCard = (key, contentKey) => {
  if (!contentKey) return;
  const v = read();
  v.dismissed[key] = contentKey;
  write(v);
};
export const resetSmartCards = () => { try { localStorage.removeItem(STORE_KEY); } catch { /* noop */ } };

// Statistiques admin (lot 554) : 1 événement par carte, par type et par contenu envoyé au serveur (vu / ouvert / masqué),
// qui ne garde qu'un drapeau par membre et par jour. `post` injecté pour rester testable sans réseau.
const reported = new Set();
export const reportSmartCardEvent = (key, event, contentKey, post) => {
  if (!key || !event || !contentKey) return false;
  const sig = `${key}|${event}|${contentKey}`;
  if (reported.has(sig)) return false;
  reported.add(sig);
  try { Promise.resolve(post("/smart-cards/event", { key, event })).catch(() => {}); } catch { /* noop */ }
  return true;
};

// Place les cartes disponibles. `prev` = décisions déjà prises dans la session ({key: {ck, at}}) : une carte
// placée garde sa place tant que son contenu (ck) ne change pas, même une fois « vue ». Les nouvelles cartes
// éligibles prennent, dans l'ordre de priorité, le premier emplacement libre : tête, puis positions du fil.
export const placeSmartCards = (available, cfg, prev = {}, positions = DEFAULT_FEED_POSITIONS, now = Date.now()) => {
  const next = {};
  cfg.order.forEach((k) => { const ck = available[k]; if (ck && prev[k]?.ck === ck) next[k] = prev[k]; });
  const used = new Set(Object.values(next).map((d) => d.at));
  const slots = ["head", ...positions];
  let overflow = positions[positions.length - 1];
  cfg.order.forEach((k) => {
    const ck = available[k];
    if (!ck || next[k] || !isCardEligible(k, ck, cfg, now)) return;
    let at = slots.find((s) => !used.has(s));
    if (at === undefined) { do { overflow += 4; } while (used.has(overflow)); at = overflow; }
    used.add(at);
    next[k] = { ck, at };
  });
  return next; // { key: { ck, at: "head" | <nb de publications avant la carte> } }
};
